import { CmmOrderTableRowData } from "../../../data-model/cmmOrderTableRowData";

// Helper function to check if a value is empty (null, undefined, or empty string)
export const isEmpty = (value: any): boolean => {
  return value === null || value === undefined || value === "";
};

// Format drug confidence score
export const formatDrugConfidenceScore = (drugConfidenceScore: any) => {
  if (isEmpty(drugConfidenceScore) || drugConfidenceScore === "--") {
    return isEmpty(drugConfidenceScore) ? "N/A" : "--";
  }
  const numValue = parseFloat(drugConfidenceScore);
  return isNaN(numValue) ? drugConfidenceScore : numValue.toFixed(2);
};

// Format dosage quantity string
export const formatDosageQuantity = (
  drugQuantity: any,
  drugQuantityQualifier: any,
) => {
  const quantity = isEmpty(drugQuantity) ? "" : drugQuantity;
  const qualifier = isEmpty(drugQuantityQualifier) ? "" : drugQuantityQualifier;
  const result = `${quantity} ${qualifier}`.trim();
  return result || "--";
};

// Format days supply
export const formatDaysSupply = (drugDaysSupply: any) => {
  if (isEmpty(drugDaysSupply)) {
    return "--";
  }
  return `${drugDaysSupply} days`;
};

export const getCorrectText = (rowData: CmmOrderTableRowData) => {
  if (rowData?.formPickedFlag?.includes("PBM")) {
    const insurer = rowData?.activeInsurance?.pbm?.insurer;
    return `PBM: ${isEmpty(insurer) ? "N/A" : insurer}`;
  }
  const rxBin =
    rowData?.type === "Internal" ? rowData?.sftpRxBin : rowData?.patientRxBin;
  return `RxBin: ${isEmpty(rxBin) ? "N/A" : rxBin}`;
};
